import { ChatContainer } from './components/ChatContainer';
import { DeAIMainOverlayUI } from './components/DeAIMainOverlayUI';
import ThreejsCanvas from './components/ThreejsCanvas'
import { Layout, Fit, Alignment } from '@rive-app/react-webgl';
import  {useDEAIService, EVENT_AI_TEXT_RESPONSE}  from "./com/akavirtual/deai/core/DEAIService";
import { useCallback, useEffect, useState } from 'react';
import { Config } from './com/akavirtual/deai/Config';

function App() {

  const deAIService = useDEAIService(Config.ENDPOINT);

  const [messages, setMessages] = useState(() => [...deAIService.messagesState]);

  const handleMessagesUpdate = useCallback(() => {
      setMessages([...deAIService.messagesState]);
  }, [deAIService.messagesState]); 

  useEffect(() => {
      deAIService.addEventListener(EVENT_AI_TEXT_RESPONSE, handleMessagesUpdate);
      return () => {
          deAIService.removeEventListener(EVENT_AI_TEXT_RESPONSE, handleMessagesUpdate);
      };
  }, [deAIService, handleMessagesUpdate]);

  return (
    <div id="canvas-container" style={{width: '100%',height: '100%'}} >
      <ThreejsCanvas />
      <DeAIMainOverlayUI 
        src={"./rive/lucy_web_mobile.riv?"+Math.random()}
        stateMachines = "HoldToTalkButton"
        animations= {["DialSpin", "BoxPulseIdle","NumbersIdle", "HeartbeatIdle"]}
        artboard= "LucyMobileScaled"
        layout={new Layout({ fit: Fit.Layout, alignment: Alignment.TopCenter })}
        autoplay= {true}
      />
      <ChatContainer 
        messages={ messages }
      />
    </div>
  )
}

export default App;
